import * as React from 'react';

import { CustomerRoleSection } from '../../components/CustomerRoleSection';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackClientTypeToggleLinkClick } from './tracking';

/**
 * Секция "В какой роли вы участвуете в сделке?".
 */
export const CustomerRoleSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { config } = useApplicationContext();

  const b2cPromoUrl = config.get<string>('deal-sale-promo-b2c-frontend.baseUrl') || /* istanbul ignore next */ '';

  return <CustomerRoleSection b2cPromoUrl={b2cPromoUrl} onClientTypeToggleLinkClick={trackClientTypeToggleLinkClick} />;
};
